import React from 'react';
export var StickyPlayerContext = React.createContext({
    stickyPlayer: {
        file: undefined,
        label: undefined,
        playing: false,
    },
    setStickyPlayer: function () { return null; },
});
